export const APP_NAME = 'Mensova';
export const APP_LOGO_ALT = APP_NAME;
export const APP_LOGO_DASHBOARD_LABEL = `${APP_NAME} - Go to dashboard`;
export const APP_AUTH_HEADING = `Sign in to ${APP_NAME}`;
